import { Checkbox, DefaultButton, IconButton, Label, Panel, PanelType, PrimaryButton } from 'office-ui-fabric-react';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { ConstrainMode, DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import React, { Component, Fragment } from 'react';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataChecklist } from '../../data/DataChecklist';
import { IDS_TYPE_MANDAT } from '../../data/DataTypeMandat';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxChecklistItem } from '../ComboBox/ComboBoxChecklistItem';
import { ComboBoxCompte } from '../ComboBox/ComboBoxCompte';
import { ComboBoxSociete } from '../ComboBox/ComboBoxSociete';
import { FicheChecklistItems_Operation } from '../Fiche/FicheChecklistItems_Operation';
import { FicheChecklistItems_Reservation } from '../Fiche/FicheChecklistItems_Reservation';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class DetailsListChecklist extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListChecklistWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListChecklistWithPerimetre extends Component {

    static defaultProps = {
        idOperation: undefined,
        idReservation: undefined,
        perimetre: {}
    };

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = true;
        this._sortedColumn = "nombreChecksManquants";
        this._objetState = {
            items: [],
            itemActif: {},
            /* --- */
            pageIndex: 1,
            facteurNbreEnregistrement: 100,
            /* --- */
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true
        };
        this.state = { ... this._objetState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onColumnHeaderClick={this._onClickColumnHeader}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            onRenderRow={this._onRenderRow}
            selectionMode={SelectionMode.none}
        />
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this.setState({ pageIndex: 1 });
        this._togglePanel("Filtres", false, null, true)();
    };

    _chargementDonnees = () => {
        const { items, facteurNbreEnregistrement, pageIndex } = this.state;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des checklists en cours..."
        });

        let chargementChecklistItems = DataChecklist._chargementChecklists(this._filtres, this._sortedColumn, this._isSortedDescending, facteurNbreEnregistrement, pageIndex);
        chargementChecklistItems.then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const checklistItems = responseFetch.reponseAPIobjet || [];

                let newItems = [];
                if (pageIndex === 1) {
                    newItems = checklistItems;
                }
                else {
                    newItems = [...items];
                    newItems = newItems.concat(checklistItems);
                }

                const state = { items: newItems };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                const state = { items: [] };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });
    };

    _getColumns = () => {

        let columns = [
            {
                isResizable: true,
                key: "operation",
                minWidth: 300,
                maxWidth: 350,
                name: "Opération",
                onRender: (item) => {
                    const operation = item.operation;
                    return <span title={operation}>{operation}</span>;
                }
            },
            {
                fieldName: "lotCommercial",
                key: "lotCommercial",
                minWidth: 100,
                maxWidth: 100,
                name: "Réservation",
            },
            {
                isResizable: true,
                key: "acquereurs",
                minWidth: 250,
                maxWidth: 250,
                name: "Acquéreurs",
                onRender: (item) => {
                    const acquereurs = item.acquereurs;
                    return <span title={acquereurs}>{acquereurs}</span>;
                }
            },
            {
                fieldName: "nombreChecksManquants",
                key: "nombreChecksManquants",
                name: "Checks manquants",
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "edit",
                minWidth: 20,
                maxWidth: 20,
                onRender: (item) => {
                    const onClick = !!item.idReservation
                        ? this._togglePanel("ChecklistItems_Reservation", true, item, false)
                        : this._togglePanel("ChecklistItems_Operation", true, item, false);
                    return <IconButton
                        iconProps={{ iconName: "Edit" }}
                        onClick={onClick}
                        title="Consulter/modifier la checklist"
                    />;
                }
            },
        ];

        return columns;
    };

    _getFarItems = () => {
        return [
            {
                key: "nombreEnregistrement",
                name: this.state.items.length
            },
            {
                iconOnly: true,
                iconProps: { iconName: "Filter" },
                key: "filtres",
                name: "Filtres",
                onClick: this._togglePanel("Filtres", true, null, false)
            }
        ];
    };

    _getFiltres = () => {
        const { idOperation, idReservation } = this.props;
        let filtres = { ...PanelFiltres.defaultProps.filtres };
        if (!!idOperation) filtres.idOperation = idOperation;
        if (!!idReservation) filtres.idReservation = idReservation;
        return filtres;
    };

    _getItems = () => {
        return [
            {
                key: "search",
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            }
        ];
    };

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    }

    _incrementeNbreEnregistrementEtChargementDonnees = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _onClickColumnHeader = (ev, column) => {
        const key = column.key;
        const isSortedDescending = !(column.isSortedDescending || false)

        this._columns.forEach((col) => {
            if (col.key === key) {
                col.isSortedDescending = isSortedDescending;
                col.isSorted = true;
            } else {
                col.isSorted = false;
                col.isSortedDescending = false;
            }
        });

        this._sortedColumn = key;
        this._isSortedDescending = isSortedDescending;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender(props)}
        </Sticky>
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _togglePanel = (nomPanel, isOpen, item, rechargerLesDonnees) => () => {
        this.setState(prevState => (
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {},
                pageIndex: rechargerLesDonnees ? 1 : prevState.pageIndex
            }),
            rechargerLesDonnees ? this._chargementDonnees : null
        );
    };

    componentDidMount = () => { this._chargementDonnees(); };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const content = this._creationContent();
        const { itemActif, afficherPanelChecklistItems_Operation, afficherPanelChecklistItems_Reservation, afficherPanelFiltres } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <PanelFiltres
                filtres={{ ...this._filtres }}
                isOpen={afficherPanelFiltres}
                onValidation={this._appliquerFiltres}
                onDismiss={this._togglePanel("Filtres", false, null, false)}
            />

            <FicheChecklistItems_Operation
                idOperation={itemActif.idOperation}
                isOpen={afficherPanelChecklistItems_Operation}
                onDismiss={this._togglePanel("ChecklistItems_Operation", false, null, true)}
            />

            <FicheChecklistItems_Reservation
                idOperation={itemActif.idOperation}
                idReservation={itemActif.idReservation}
                isOpen={afficherPanelChecklistItems_Reservation}
                onDismiss={this._togglePanel("ChecklistItems_Reservation", false, null, true)}
            />

        </Fragment>;

    };

};

export class PanelFiltres extends Component {

    /*
    ******************************************************************************************************
    PROPS :
        ATTRIBUTS :
            object  filtres                             liste des filtres (clé/valeur)
            bool    isOpen                              détermine si panel ouvert ou non
        METHODES :
            void    onDismiss                           méthode appelée lorsque l'utilisateur clique sur "Annuler"
            void    onValidation(filtres)               méthode appelée lorsque l'utilisateur clique sur "Valider"
    ******************************************************************************************************
    */

    static defaultProps = {
        filtres: {
            nombreChecksManquantsMin: 1,
            idChecklistItem: 0,
            afficherChecksObligatoires: true,
            afficherChecksOptionnels: false,
            afficherChecksObtenus: false,
            afficherChecksNonObtenus: true,
            idSocieteSelectionne: 0,
            loginCompte: "",
        }
    };

    constructor(props) {
        super(props);
        this.state = {};
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidation(filtres);
    };

    _reinitialiserFiltres = () => {
        this.setState({ ...PanelFiltres.defaultProps.filtres });
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    _onRenderFooterContent = () => {
        return <Stack horizontal gap={8}>
            <PrimaryButton onClick={this._appliquerFiltres}>Valider</PrimaryButton>
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    _onChangeSociete = (value) => {
        this.setState({
            idSocieteSelectionne: value,
            loginCompte: ''
        });
    };

    render = () => {

        const {
            nombreChecksManquantsMin,
            idSocieteSelectionne, loginCompte,
            idChecklistItem, afficherChecksObligatoires, afficherChecksOptionnels, afficherChecksObtenus, afficherChecksNonObtenus
        } = this.state;

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText="Filtres"
            isOpen={this.props.isOpen}
            onDismiss={this.props.onDismiss}
            onOpen={this._onOpen}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.smallFixedFar}
        >
            <Stack>

                <Stack horizontal reversed>
                    <IconButton
                        iconProps={{ iconName: 'ClearFilter' }}
                        className="buttonFiltres"
                        title="Réinitialiser les filtres"
                        ariaLabel="Filtres"
                        onClick={this._reinitialiserFiltres}
                    />
                </Stack>

                <Label>Checklists</Label>
                <Checkbox
                    label="Incomplètes uniquement"
                    checked={nombreChecksManquantsMin > 0}
                    onChange={(e, isChecked) => this.setState({ nombreChecksManquantsMin: isChecked ? 1 : 0 })}
                />

                <ComboBoxChecklistItem
                    onChange={(event, option, index, value) => this.setState({ idChecklistItem: option.key })}
                    selectedKey={idChecklistItem}
                    styles={{ container: { paddingBottom: "5px" } }}
                />
                <Checkbox
                    checked={afficherChecksObligatoires}
                    disabled={!idChecklistItem}
                    label="Obligatoire"
                    onChange={(e, isChecked) => this.setState({ afficherChecksObligatoires: isChecked ? 1 : 0 })}
                />
                <Checkbox
                    checked={afficherChecksOptionnels}
                    disabled={!idChecklistItem}
                    label="Non obligatoire"
                    onChange={(e, isChecked) => this.setState({ afficherChecksOptionnels: isChecked ? 1 : 0 })}
                />
                <Checkbox
                    checked={afficherChecksObtenus}
                    disabled={!idChecklistItem}
                    label="Obtenu"
                    onChange={(e, isChecked) => this.setState({ afficherChecksObtenus: isChecked ? 1 : 0 })}
                />
                <Checkbox
                    checked={afficherChecksNonObtenus}
                    disabled={!idChecklistItem}
                    label="Non obtenu"
                    onChange={(e, isChecked) => this.setState({ afficherChecksNonObtenus: isChecked ? 1 : 0 })}
                />

                <ComboBoxSociete
                    onChange={(event, option, index, value, item) => this._onChangeSociete(item.idSociete)}
                    selectedKey={idSocieteSelectionne}
                />

                <ComboBoxCompte
                    disabled={!idSocieteSelectionne}
                    idSociete={idSocieteSelectionne}
                    idsTypesMandats={[IDS_TYPE_MANDAT.COMMERCIALISATEUR]}
                    label="Commercialisateur"
                    selectedKey={loginCompte}
                    onChange={(event, option, index, value) => {
                        const loginCompte = option.key !== "0" ? option.key : "";
                        this.setState({ loginCompte });
                    }}
                />

            </Stack>
        </Panel>;

    };

};